(function(angular) {
    'use strict';

    // TODO: move to separate module that has models
    angular.module('aprima-legacy-common').factory('DoseRangeInfo', [
        'DoseRange',
        'ObjUtil',
        DoseRangeInfoFactory,
    ]);

    function DoseRangeInfoFactory(
        DoseRange,
        ObjUtil
    ) {

        DoseRangeInfo.mapFromDto = mapFromDto;
        return DoseRangeInfo;

        function DoseRangeInfo(obj) {
            DoseRange.call(this, obj);

            ObjUtil.defineReadonlyProps(this, {
                MaxMinInformation: obj.MaxMinInformation,
            });
        }

        function mapFromDto(obj) {
            if(!obj) {
                return null;
            }

            return new DoseRangeInfo(obj);
        }
    }

})(window.angular);
